"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugMode = void 0;
exports.debug = debug;
exports.debugMode = {
    value: false,
};
function debug(...args) {
    if (exports.debugMode.value) {
        // eslint-disable-next-line no-console
        console.log(">>> gol:", ...args);
    }
}
